import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  makeGetSelectedReportSfdcId,
  makeGetValidationIsDone,
} from 'Modules/PeopleImportDialog/submodules/reports/selectors/validateReport';

import ValidationTrigger from './ValidationTrigger';
import ValidationResult from './ValidationResult';

type ReportValidatorPropTypes = {
  classes?: {
    root: string;
    templateContainer: string;
    expandButtonContainer: string;
    expandButton: string;
  };
  groupId: string;
  objectType: string;
};

const ReportValidator: React.FC<ReportValidatorPropTypes> = ({
  classes,
  groupId,
  objectType,
}) => {
  const reportSfdcId = useSelector(makeGetSelectedReportSfdcId(groupId));
  const validationIsDone = useSelector(makeGetValidationIsDone(reportSfdcId));

  if (!reportSfdcId) return null;

  return (
    <div>
      {validationIsDone && <ValidationResult reportSfdcId={reportSfdcId} />}
      <ValidationTrigger
        classes={classes}
        groupId={groupId}
        objectType={objectType}
      />
    </div>
  );
};

export default ReportValidator;
